module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter_fm1",
    attrs: {
      "id": "c01"
    }
  }, [_c('span', {
    staticClass: "chapter_fm1"
  }, [_vm._v("c. 500,000 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Crystals")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("A great number of chemical compounds will form crystals under the right conditions. Temperature is crucial—many things that we think of as liquids (or even gases) under “ordinary” conditions will crystallize if they’re cooled down enough. Generally, a compound has to be fairly pure and fairly concentrated to crystallize well, and it has to have a regular enough structure to arrange itself into a repeated pattern. Compounds made of long disorderly chains—such as paraffin or fatty acids—turn into waxy solids, instead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Crystallization also depends on how quickly a solution is cooled down and how it is stirred. Two spectacular examples of crystallization can be found in Mexican caves discovered by a mining operation. In 1910, Cueva de las Espadas (Cave of Swords), with impressive one-meter-long gypsum (calcium sulfate) crystals, was found around four hundred feet below sea level. It wasn’t until the year 2000 that miners uncovered the majestic Cueva de los Cristales (Cave of Crystals) at a depth of one thousand feet. The best theory for what led to these colossal formations (the largest being around forty feet tall and weighing fifty-five tons) involves processes that can only happen on geological timescales. The cave formed on the Naica fault line in the Chihuahuan Desert of north-central Mexico and filled with ground water, which a magma chamber kept heated for hundreds of thousands of years. The water became totally saturated with calcium sulfate, which dissolves well in hot water, and then the whole mixture spent another extended period of at least five hundred thousand years slowly cooling down. These are perfect conditions for growing huge crystals, and it’s not easy to find any larger than these.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gypsum itself is a common mineral that crystallizes in several different forms, depending on the conditions. It’s one of the main ingredients in plaster (with the common name plaster of paris referring to the ancient gypsum mines found in the Montmartre district of Paris), but no other deposits around the world are as spectacular as those found at the Cave of Crystals.")]), _vm._v(" "), _c('p', {
    staticClass: "seealso"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X-Ray Crystallography (1912)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quasicrystals (1984)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coordination Frameworks (1997)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recrystallization and Polymorphs (1998)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "dis_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/015.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("In what looks like a scene from a science fiction movie, a cave explorer stands among some of the largest crystals on Earth in the Cave of Crystals.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e4f9a37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c01.vue
// module id = 78
// module chunks = 0